<template>
    <div class="blog-page">
        <div class="container py-4 blog-container">
            <b-row>
                <b-col cols="12" lg="8" class="mb-3 mb-lg-0">
                    <div v-if="isProcessing" class="card-shell p-3">
                        <ContentLoader width="100%" height="420">
                            <rect x="0" y="0" rx="10" ry="10" width="100%" height="56" />
                            <rect x="0" y="70" rx="10" ry="10" width="60%" height="22" />
                            <rect x="0" y="108" rx="10" ry="10" width="100%" height="230" />
                            <rect x="0" y="354" rx="10" ry="10" width="100%" height="54" />
                        </ContentLoader>
                    </div>

                    <div v-else-if="postNotFound" class="card-shell p-4 empty-state">
                        <h1 class="blog-title mb-2">Artikel tidak ditemukan</h1>
                        <p class="mb-0">Artikel mungkin sudah dihapus atau URL tidak valid.</p>
                    </div>

                    <article v-else-if="post" class="card-shell article-shell">
                        <h1 class="blog-title">{{ post.title }}</h1>

                        <div class="article-meta mt-2 mb-3">
                            <span class="meta-pill" v-if="post.date">
                                <font-awesome-icon icon="calendar-alt" aria-hidden="true" /> {{ post.date }}
                            </span>
                            <span class="meta-pill" v-if="post.views">
                                <font-awesome-icon icon="eye" aria-hidden="true" /> {{ post.views }} dilihat
                            </span>
                        </div>

                        <div v-if="post.category && post.category.length" class="meta-tags mb-3">
                            <b-link
                                v-for="category, index of post.category"
                                :key="category.id"
                                @click="gotoCategory(category.title)"
                                class="tag-chip"
                            >
                                <font-awesome-icon v-if="index === 0" icon="tag" class="mr-1" aria-hidden="true" />
                                {{ category.title }}
                            </b-link>
                        </div>

                        <div v-if="convertUrl" class="video-wrap mb-3">
                            <b-embed
                                type="iframe"
                                aspect="16by9"
                                :src="convertUrl"
                                allowfullscreen
                                :title="'Video tutorial: ' + post.title"
                            ></b-embed>
                        </div>

                        <div class="article-content" v-html="post.description" :aria-label="'Konten artikel: ' + post.title"></div>

                        <div v-if="blogAdHtml" class="ad-wrap mt-4" v-html="blogAdHtml"></div>
                    </article>
                </b-col>

                <b-col cols="12" lg="4">
                    <div class="sidebar-block card-shell mb-3">
                        <h6 class="sidebar-title">Cari Artikel</h6>
                        <b-form @submit.prevent="goToSearch">
                            <div class="input-group input-full-width">
                                <b-input
                                    v-model="searchQuery"
                                    type="text"
                                    placeholder="Cari topik blog"
                                    aria-label="Cari artikel"
                                ></b-input>
                                <div class="input-group-append">
                                    <b-button type="submit" variant="primary" class="search-btn" aria-label="Cari artikel">Cari</b-button>
                                </div>
                            </div>
                        </b-form>
                    </div>

                    <div class="sidebar-block card-shell mb-3">
                        <h6 class="sidebar-title">Kategori</h6>
                        <div class="category-wrap">
                            <b-link :to="{name: 'version2-blog-list'}" class="category-chip all-chip">
                                Semua
                            </b-link>
                            <b-link
                                v-for="category, index in category_list"
                                :key="index"
                                @click="gotoCategory(category.text)"
                                class="category-chip"
                            >
                                {{ category.text }}
                            </b-link>
                        </div>
                    </div>

                    <div v-if="latestPostList.length > 0" class="sidebar-block card-shell">
                        <h6 class="sidebar-title">Artikel Terbaru</h6>
                        <div class="latest-list">
                            <div
                                v-for="post, index in latestPostList"
                                :key="index"
                                class="latest-item"
                                :class="{'latest-item-border': latestPostList.length - 1 !== index}"
                            >
                                <b-link @click="goto(post)" class="latest-link text-ip">
                                    {{ post.title }}
                                </b-link>
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import { mapState } from 'vuex';
import { ContentLoader } from "vue-content-loader"
import {BEmbed} from 'bootstrap-vue'

export default {
    props: ['day', 'month', 'year', 'slug'],
  components: {
        ContentLoader,
        BEmbed
  },
  computed: {
    ...mapState(["blog"]),
        category_list() {
            if (this.blog.categoryList)
                return this.blog.categoryList
            return []
    },
        convertUrl() {
            if (this.post && this.post.ytb_video_id)
                return `https://www.youtube.com/embed/${this.post.ytb_video_id}`
            return null
    },
  },

  created() {
    this.fetchPost()
    this.fetchCategoryList()
    this.fetchLatestPostList()
    this.getCompanyCode()
    this.getBlogAd()
  },

  data() {
    return {
            companyCode: null,
            blogAdHtml: null,
            post: null,
            postList: [],
            postCount: null,
            perPage: 20,
            latestPostList: [],
            searchQuery: null,
            isSearching: false,
            isProcessing: false,
            postNotFound: false,
    };
  },

  methods: {
        gotoCategory(title) {
            this.$router.push({
                name: 'version2-blog-category',
                params: { category_name: title }
            })
        },
        goToSearch() {
            if (this.searchQuery) {
                this.$router.push({ path: '/blog/', query: { search: this.searchQuery } })
            }
    },
    getCompanyCode() {
            axios.get("/api/get-company-code/")
                .then(resp => {
                    if (resp.status == 200) {
                        this.companyCode = resp.data.company_code
                    }
                })
    },
    getBlogAd() {
            axios.get("/api/get-blog-ad/")
                .then(resp => {
                    if (resp.status == 200) {
                        this.blogAdHtml = resp.data.ad_html
                    }
                })
        },
        setMeta(title) {
            const fullTitle = 'InstaPrivat - ' + title
            document.title = fullTitle
            // Update meta description with article title
            let metaDesc = document.querySelector('meta[name="description"]')
            if (metaDesc) metaDesc.setAttribute('content', title)
            // Update Open Graph tags
            let ogTitle = document.querySelector('meta[property="og:title"]')
            if (ogTitle) ogTitle.setAttribute('content', fullTitle)
            let ogDesc = document.querySelector('meta[property="og:description"]')
            if (ogDesc) ogDesc.setAttribute('content', title)
            let ogUrl = document.querySelector('meta[property="og:url"]')
            if (ogUrl) ogUrl.setAttribute('content', window.location.href)
            // Update Twitter Card
            let twTitle = document.querySelector('meta[name="twitter:title"]')
            if (twTitle) twTitle.setAttribute('content', fullTitle)
            let twDesc = document.querySelector('meta[name="twitter:description"]')
            if (twDesc) twDesc.setAttribute('content', title)
    },
    fetchPost() {
            this.isProcessing = true
            this.postNotFound = false
            axios.get(`/api/v1/blog/posts/${this.slug}/`)
                .then(resp => {
                    if (resp.status == 200) {
                        this.isProcessing = false
                        this.post = resp.data
                        this.setMeta(resp.data.title)
                    }
                })
                .catch(error => {
                    this.isProcessing = false
                    if (error.response && error.response.status == 404) {
                        this.postNotFound = true
                    }
                })
    },
    fetchCategoryList() {
            this.$store.dispatch('blog/getAllCategories')
    },
    fetchLatestPostList() {
            if (this.isSearching == false) {
                axios.get(`/api/v1/blog/posts/?page_size=6&page=${this.$route.query.page || 1}`)
                    .then(resp => {
                        if (resp.status == 200) {
                            this.latestPostList = resp.data.results
                        }
                    })
            } else this.searchPost()
    },
        goto(post) {
        const parts = post.date.split("-");
                var day = parseInt(parts[parts.length - 1])
                var month = parseInt(parts[parts.length - 2])
                var year = parseInt(parts[parts.length - 3])
                this.$router.push({
                    name: 'version2-blog-detail',
                    params: { day: day, month: month, year: year, slug: post.slug }
                })
                    .catch(error => { })
    },
        searchPost() {
            if (this.searchQuery) {
                axios.get(`/api/v1/blog/posts/?search=${this.searchQuery}&page_size=${this.perPage}&page=${this.$route.query.page || 1}`)
                    .then(resp => {
                        if (resp.status == 200) {
                            this.postList = []
                            this.postList = resp.data.results
                            this.postCount = resp.data.count
                            this.isSearching = true
                        }
                    })
            }
    },
  },
  watch: {
        '$route.params.slug': function () {
            this.$nextTick(() => {
                this.fetchPost()
            })
    }
  }
};
</script>

<style scoped>
.blog-page {
    background: linear-gradient(180deg, #f7fafc 0%, #f1f6fa 100%);
    min-height: 100vh;
}

.blog-container {
    font-size: 14px;
}

.text-ip {
    color: #0f6b87 !important;
}

.card-shell {
    background: #ffffff;
    border: 1px solid #e5edf3;
    border-radius: 12px;
    box-shadow: 0 4px 18px rgba(12, 56, 74, 0.06);
    padding: 1rem 1.1rem;
}

.blog-title {
    font-size: 1.7rem;
    font-weight: 700;
    line-height: 1.35;
    color: #123548;
    margin-bottom: 0;
}

.article-shell {
    padding: 1.1rem 1.2rem;
}

.article-meta {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
}

.meta-pill {
    display: inline-flex;
    align-items: center;
    gap: 0.3rem;
    font-size: 12px;
    color: #4b6170;
    background: #eef5f9;
    border: 1px solid #d7e6ef;
    border-radius: 999px;
    padding: 0.22rem 0.6rem;
}

.meta-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 0.45rem;
}

.tag-chip {
    display: inline-flex;
    align-items: center;
    font-size: 12px;
    color: #0f6b87 !important;
    background: #eef6fb;
    border: 1px solid #d5e7f2;
    border-radius: 999px;
    padding: 0.28rem 0.58rem;
    text-decoration: none;
}

.tag-chip:hover {
    color: #fff !important;
    background: #0f6b87;
    border-color: #0f6b87;
}

.video-wrap {
    border-radius: 10px;
    overflow: hidden;
    border: 1px solid #e3edf3;
}

.article-content {
    color: #2c4352;
    line-height: 1.8;
    font-size: 15px;
    word-break: break-word;
}

.ad-wrap {
    border-radius: 10px;
    border: 1px solid #e4edf3;
    background: #f7fbff;
    padding: 1rem;
}

.empty-state p {
    color: #607683;
}

.sidebar-title {
    color: #1d3a4a;
    font-weight: 700;
    margin-bottom: 0.8rem;
}

.search-btn {
    min-width: 70px;
    background: #0f6b87;
    border-color: #0f6b87;
}

.search-btn:hover,
.search-btn:focus {
    background: #0d5f78;
    border-color: #0d5f78;
}

.category-wrap {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
}

.category-chip {
    display: inline-flex;
    align-items: center;
    font-size: 12px;
    padding: 0.3rem 0.6rem;
    border-radius: 999px;
    color: #0f6b87 !important;
    background: #eef6fb;
    border: 1px solid #d5e7f2;
    text-decoration: none;
}

.category-chip:hover {
    color: #fff !important;
    background: #0f6b87;
    border-color: #0f6b87;
}

.all-chip {
    background: #fff7dc;
    border-color: #f5de95;
    color: #8a6514 !important;
}

.latest-item {
    padding: 0.45rem 0;
}

.latest-item-border {
    border-bottom: 1px solid #ebf1f5;
}

.latest-link {
    font-size: 13px;
    line-height: 1.45;
}

@media (max-width: 991px) {
    .blog-title {
        font-size: 1.4rem;
    }

    .article-shell {
        padding: 1rem;
    }
}
</style>